import Image from "~/components/ui/Image"
import { type Group, useFAQ } from "~/components/institutional/FAQ/useFAQ"

export default function Group(group: Group) {
    const { selectedGroup, setSelectedGroup } = useFAQ()

    return (
        <button
            className='w-full h-[115px] px-5 border border-salmon rounded-lg bg-white grid justify-items-center content-center gap-2 transition-color duration-300 cursor-pointer group data-[selected=true]:bg-salmon md:w-[215px] md:h-36'
            data-selected={group.label === selectedGroup?.label}
            onClick={() => setSelectedGroup(group)}
        >
            <Image
                className='transition-all duration-300 group-data-[selected=true]:brightness-[500%]'
                src={group.icon}
                alt={group.label}
                width={group.width ?? 40}
                height={group.height ?? 40}
            />

            <h3 className='text-salmon text-center leading-none font-bold transition-color duration-300 group-data-[selected=true]:text-white'>
                {group.label}
            </h3>
        </button>
    )
}
